import styled, {css} from 'styled-components';
import { JackpotType } from '../../../../../common/const/jackpot_map_ids';
import {JACKPOT_WIDGET_LAYOUT} from '../../jackpot-widget.component';
import {OrbitTheme} from '../../../../themes/architecture/orbit-theme.interface';

export interface IJackpotWidgetBgBoxProps {
    jackpotType: JackpotType;
    layout: JACKPOT_WIDGET_LAYOUT;
    shouldRenderSkeleton?: boolean;
}

const handleBackgroundImage = (props: IJackpotWidgetBgBoxProps, theme: OrbitTheme) => {
    if (props.shouldRenderSkeleton) {
        return 'none';
    }
    if (
        (props.layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE || props.layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE) &&
        theme.images.jackpotWidget.byType[props.jackpotType].landscape?.background
    ) {
        return 'url(' + theme.images.jackpotWidget.byType[props.jackpotType].landscape.background.toString() + ')';
    }
    return 'url(' + theme.images.jackpotWidget.byType[props.jackpotType].background.toString() + ')';
}

export const JackpotWidgetBgBox = styled.div<IJackpotWidgetBgBoxProps>`
    background-image: ${props => handleBackgroundImage(props, props.theme) };
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-radius: 10px;

    ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        flex-direction: row;
        align-items: center;
    `}

    animation: JackpotBackgroundLoadingAnimation 1.5s linear infinite;

    @keyframes JackpotBackgroundLoadingAnimation {
        0% {
            background-color: #000000;
        }
        50% {
            background-color: #171717;
        }
        100% {
            background-color: #000000;
        }
    }
`;
